import { ITreeNodeData } from "../../../treeview/types/TreeNodeData";

export const applyInitialExpansionState = <T>(
    node: ITreeNodeData<T> | null
): ITreeNodeData<T> | null => {
    if (!node) return node;

    return {
        ...node,
        isExpanded: node.level === 0,
        children: node.children?.map(child =>
            applyInitialExpansionState(child)
        ) || []
    };
};

export const updateTreeNodeState = <T>(
    node: ITreeNodeData<T> | null,
    targetId: number,
    selectedId?: number
): ITreeNodeData<T> | null => {
    if (!node) return node;

    const hasChildren = !!(node.children && node.children.length > 0);
    const isTarget = node.id === targetId;
    const isPreviouslySelected = selectedId !== undefined && node.id === selectedId;

    const updatedNode: ITreeNodeData<T> = {
        ...node,
        active: isTarget,
        children: node.children?.map(child =>
            updateTreeNodeState(child, targetId, selectedId)
        ) || []
    };

    if (isTarget && hasChildren) {
        const isSameSelectedNode = selectedId === targetId;
        updatedNode.isExpanded = isSameSelectedNode
            ? !node.isExpanded
            : true;
    }

    if (!isTarget && isPreviouslySelected) {
        updatedNode.active = false;
    }

    return updatedNode;
};